module.exports = __webpack_public_path__ + "static/img/bg-ar.b900c8c4.png";